<template>
  <div class="pagetdetial">
    <md-field class="other">
      <md-cell-item title="快遞單號" v-if="par.status != 12">
        <span class="holder" slot="right">{{ par.expressNumber }}</span>
      </md-cell-item>
      <md-cell-item title="包裹單號" v-if="par.status == 12">
        <span class="holder" slot="right">{{ par.expressNumber }}</span>
      </md-cell-item>
      <md-cell-item title="收貨倉庫" v-if="par.status != 12">
        <span class="holder" slot="right">{{ par.warehouse }}</span>
      </md-cell-item>
      <md-cell-item title="到貨倉庫" v-if="par.status == 12">
        <span class="holder" slot="right">{{ par.warehouse }}</span>
      </md-cell-item>
      <md-cell-item title="包裹标注" v-if="par.status >= 21">
        <span v-if="par.remark" class="holder" slot="right">{{ par.remark }}</span>
      </md-cell-item>
      <md-cell-item title="拆包" v-if="par.status >= 21 && par.isParcelUnpack != null">
        <span v-if="par.isParcelUnpack" class="holder" slot="right">拆包发货</span>
        <span v-if="!par.isParcelUnpack" class="holder" slot="right">不拆包发货</span>
      </md-cell-item>
      <md-cell-item title="貨物類型" v-if="par.type == 1">
        <span class="holder" slot="right" style="color: #32c5ea">特貨</span>
      </md-cell-item>
      <md-cell-item title="狀態">
        <span class="holder" slot="right" v-if="par.status < 11" style="color: #e51c23">待入庫</span>
        <span class="holder" slot="right" v-if="par.status == 11 || par.status == 14" style="color: #e51c23">待補資料</span>
        <span class="holder" slot="right" v-if="par.status == 12" style="color: #e51c23">待合包</span>
        <span class="holder" slot="right" v-if="par.status == 13" style="color: #e51c23">超期</span>
        <span class="holder" slot="right" v-if="par.status == 21" style="color: #e51c23">拒收尺寸超标</span>
        <span class="holder" slot="right" v-if="par.status == 22" style="color: #e51c23">拒收包裹超重</span>
        <span class="holder" slot="right" v-if="par.status == 23" style="color: #e51c23">拒收违禁物品</span>
        <span class="holder" slot="right" v-if="par.status == 24" style="color: #e51c23">拒收涉嫌侵权</span>
        <span class="holder" slot="right" v-if="par.status == 31" style="color: #e51c23">已合包</span>
        <span class="holder" slot="right" v-if="par.status == 32" style="color: #e51c23">已销毁</span>
        <span class="holder" slot="right" v-if="par.status == 33" style="color: #e51c23">退货中</span>
        <span class="holder" slot="right" v-if="par.status == 34" style="color: #e51c23">退货完成</span>
      </md-cell-item>
      <md-cell-item title="附加费" v-if="par.surchargesMemo">
        <span class="holder" slot="right">{{ par.surchargesMemo }}{{ par.surchargesMoney }}CNY</span>
      </md-cell-item>
      <md-cell-item title="特殊品名" v-if="par.isSpecialGoodsStr">
        <span class="holder" slot="right">{{ par.isSpecialGoodsStr }}</span>
      </md-cell-item>
      <md-cell-item title="描述" v-if="par.status >= 21 && par.status <= 24 && par.statusDoc">
        <span class="holder" slot="right">{{ par.statusDoc }}</span>
      </md-cell-item>
      <md-cell-item title="免費倉儲" v-if="
        (par.status < 21 || par.status > 24) &&
        par.statusDoc && par.status != 13
      ">
        <span class="holder" slot="right" v-if="par.storageDays >= 0">{{ par.storageDays }}天</span>
        <span class="holder" slot="right" v-if="par.storageDays < 0">{{ -par.storageDays }}天</span>
      </md-cell-item>
      <md-cell-item title="距銷毀" v-if="
        (par.status < 21 || par.status > 24) &&
        par.statusDoc && par.status == 13
      ">
        <span class="holder" slot="right" v-if="par.storageDays >= 0">{{ par.storageDays }}天</span>
        <span class="holder" slot="right" v-if="par.storageDays < 0">{{ -par.storageDays }}天</span>
      </md-cell-item>
      <md-cell-item title="入庫時間" v-if="par.status < 21 || par.status > 24">
        <span class="holder" slot="right">{{
          par.deliveryTime | dateformat("YYYY-MM-DD HH:mm")
          }}</span>
      </md-cell-item>
      <md-cell-item title="合包時間" v-if="par.status >= 21 && par.status <= 24">
        <span class="holder" slot="right">{{
          par.deliveryTime | dateformat("YYYY-MM-DD HH:mm")
          }}</span>
      </md-cell-item>
      <md-cell-item title="包裹照片"> </md-cell-item>
      <img :src="par.imgs[0]" alt="" style="width: 50%" @click="isViewerShow = true" />
    </md-field>
    <md-field style="margin-top: 0.2rem">
      <md-cell-item title="實重" v-if="par.realWeight">
        <span class="holder" slot="right">{{ par.realWeight }}KG</span>
      </md-cell-item>
      <md-cell-item title="包裹尺寸" v-if="par.length > 0 && par.width > 0">
        <span class="holder" slot="right">{{ par.length }} * {{ par.width }} * {{ par.height }} (cm)</span>
      </md-cell-item>
      <md-cell-item title="體積重" v-if="par.width > 0 && par.bulk > 0 && par.status >= 31">
        <span class="holder" slot="right">{{ par.bulk }}KG</span>
      </md-cell-item>
      <md-cell-item title="計費重" v-if="par.bulk > 0 && par.status == 31" :no-border="par.type == 1 ? false : true">
        <span class="holder" slot="right" v-if="par.bulk < par.weight">{{ par.weight }}KG
          <span class="tip">*計費重量為實重/體積重取大者</span></span>
        <span class="holder" slot="right" v-if="par.bulk >= par.weight">{{ par.bulk }}KG
          <span class="tip">*計費重量為實重/體積重取大者</span></span>
      </md-cell-item>
      <md-cell-item title="體積">
        <span class="holder" slot="right">{{ par.volume }}CBM</span>
      </md-cell-item>
      <md-cell-item title="貨物類型" v-if="par.type == 1">
        <span class="holder" slot="right" style="color: #e51c23">特貨</span>
      </md-cell-item>
      <md-cell-item title="物品總值" v-if="par.type == 1" no-border>
        <md-amount :value="par.totalPrice" has-separator class="holder" slot="right"
          style="color: #32c5ea">CNY</md-amount>
      </md-cell-item>
      <md-cell-item title="包裹标注" v-if="par.status < 21">
        <md-input-item ref="name" v-if="(par.isCheck === 0 && par.status === 14) || par.status < 21" preview-type="text"
          v-model="par.remark" placeholder="请输入包裹标注" slot="right"></md-input-item>
        <span class="holder" slot="right" v-else><span v-if="par.remark">{{ par.remark }}</span></span>
      </md-cell-item>
      <md-cell-item title="拆包" v-if="par.status < 21 && isParceldetail.isParcelUnpack">
        <div style="width: 100%;display: flex;justify-content: space-between" @click="value1 = true" slot="right">
          <span v-if="parcelUnpack">拆包发货</span>
          <span v-if="!parcelUnpack">不拆包发货</span>
          <img src="@/assets/image/icon_dropdown.png" alt="" style="width: 0.4rem" />
        </div>
      </md-cell-item>
    </md-field>
    <p style="font-size: 0.3rem;margin-top: 0.2rem;text-align: left;padding-left: 0.4rem">
      物品資訊
    </p>
    <goodlist-modal ref="modal" style="margin-top: 0.2rem" @submitform="submitform" />
    <md-image-viewer v-model="isViewerShow" :list="par.imgs" :has-dots="true">
    </md-image-viewer>
    <md-action-sheet v-model="value1" title="请选择是否拆包发货" :cancel-text="cancelText" :options="optionstwo"
      @selected="$_selectedtwo"></md-action-sheet>
  </div>
</template>

<script>
import {
  Button,
  Field,
  FieldItem,
  Icon,
  InputItem,
  CellItem,
  Stepper,
  Toast,
  ImageViewer,
  Amount, Switch, Dialog, ActionSheet
} from "mand-mobile";
import GoodlistModal from "./Modal/GoodlistModal";
import eventBus from "../../until/eventBus";

export default {
  name: "packdetail",
  components: {
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [Switch.name]: Switch,
    [Dialog.name]: Dialog,
    [Field.name]: Field,
    [ActionSheet.name]: ActionSheet,
    [ImageViewer.name]: ImageViewer,
    [CellItem.name]: CellItem,
    [Icon.name]: Icon,
    [Amount.name]: Amount,
    [FieldItem.name]: FieldItem,
    [Stepper.name]: Stepper,
    // eslint-disable-next-line vue/no-unused-components
    GoodlistModal
  },
  data() {
    return {
      isParceldetail: {
        isParcelUnpack: false,
        text: '',
      },
      value1: false,
      cancelText: '取消',
      optionstwo: [
        {
          label: '拆包发货',
          value: true,
        },
        {
          label: '不拆包发货',
          value: false,
        },
      ],
      parcelUnpack: true,
      addshow: false,
      isfrsh: true,
      isViewerShow: false,
      par: {
        imgs: [require("@/assets/image/empty.png")]
      }
    };
  },
  beforeRouteLeave(to, form, next) {
    this.isfrsh = true;
    this.addshow = false;
    next();
  },
  activated() {
    eventBus.$on(
      "goodeNameinfo",
      function (data, index) {
        if (this.$refs.modal != undefined && data) {
          this.$refs.modal.list[index].name = data;
          this.isfrsh = false;
          this.addshow = true;
        } else {
          this.isfrsh = true;
        }
      }.bind(this)
    );
    eventBus.$on(
      "goodeUrlinfo",
      function (data, index) {
        if (this.$refs.modal != undefined && data) {
          this.isfrsh = false;
          this.addshow = true;
          this.$set(this.$refs.modal.list[index], "url", data);
        } else {
          this.isfrsh = true;
        }
      }.bind(this)
    );
    if (this.isfrsh) {
      Toast.loading("加載中...");
      this.getdetail();
    }
  },
  methods: {
    $_selectedtwo(item) {
      if (!item.value) {
        Dialog.confirm({
          title: '提示',
          content: this.isParceldetail.text,
          cancelText: '取消',
          confirmText: '确定',
          onConfirm: () => {
            this.parcelUnpack = false
          },
          onCancel: () => {
            this.parcelUnpack = true
          }
        })
      } else {
        this.parcelUnpack = item.value
      }
      // this.parcelType=item.label
      // console.log('action-sheet selected:', JSON.stringify(item))
    },
    cheurusner() {
      if (!this.parcelUnpack) {
        Dialog.confirm({
          title: '提示',
          content: this.isParceldetail.text,
          cancelText: '取消',
          confirmText: '确定',
          onConfirm: () => {
            this.parcelUnpack = false
          },
          onCancel: () => {
            this.parcelUnpack = true
          }
        })
      }
    },
    submitform() {
      Toast.loading("请稍等...");
      const par = {
        id: this.$route.query.id,
        isParcelUnpack: this.isParceldetail.isParcelUnpack ? this.parcelUnpack : null,
        products: this.$refs.modal.list,
        remark: this.par.remark
      };
      if (this.par.status === 11 || (this.par.isCheck === 0 || this.par.status === 14)) {
        this.http
          .APIASK(this.ports.parcelcomplete, "post", par)
          .then(res => {
            localStorage.setItem("fleshpack", "11");
            this.$router.go(-1);
            Toast.hide();
          })
          .catch(err => {
            Toast.hide();
          });
      } else {
        this.http
          .APIASK(this.ports.updateProductPrices, "post", this.$refs.modal.list)
          .then(res => {
            localStorage.setItem("fleshpack", "11");
            this.$router.go(-1);
            Toast.hide();
          })
          .catch(err => {
            Toast.hide();
          });
      }

    },
    getwhous(id) {
      // console.log(JSON.parse(localStorage.getItem('countryList')))
      var findevalue = JSON.parse(localStorage.getItem("countryList")).find(
        val => {
          return val.id == id;
        }
      );
      var thant = this;
      setTimeout(function () {
        thant.$refs.modal.conuntrycode = findevalue;
      }, 10);
    },
    isParcelType(countryId) {
      this.http.APIASK(this.ports.isParcelUnpack, 'get', { countryId }).then(resut => {
        this.isParceldetail = resut

      })
    },
    getdetail() {
      const par = {
        id: this.$route.query.id
      };
      this.http
        .APIASK(this.ports.arcel, "get", par)
        .then(res => {
          this.isParcelType(res.countryId);
          this.getwhous(res.countryId);
          res.isParcelUnpack === null ? this.parcelUnpack = true : this.parcelUnpack = res.isParcelUnpack
          this.par = res;
          if (this.par.remark === null) {
            this.par.remark = ''
          }
          this.par.imgs = [];
          console.log(this.par);
          this.par.image
            ? (this.par.imgs[0] = this.par.image)
            : (this.par.imgs = [require("@/assets/image/empty.png")]);
          var that = this;
          setTimeout(function () {
            console.log(that.par)
            that.$refs.modal.list = that.par.list;
            that.$refs.modal.allprice = that.par.totalPrice;
            if (that.par.status < 20) {
              if (that.par.isCheck === 0) {
                // isCheck为0 GoodlistModal都能编辑
                that.$refs.modal.isCheckBack();
              } else {
                if(that.par.list.length>0){
                  that.$refs.modal.ishuri();
                }

              }
            }
          }, 10);
          Toast.hide();
          that.addshow = true;
        }).catch(err => {
          Toast.hide();
          this.addshow = false;
        });
    }
  }
};
</script>

<style lang="less">
.pagetdetial {
  .other.md-field {
    padding: 0 0.4rem;
  }

  .md-cell-item-title {
    text-align: left;
  }

  .md-cell-item-right {
    text-align: left;
    width: 70%;
    display: flex;
    justify-content: flex-start !important;
  }

  .md-image-viewer .viewer-item-wrap .item {
    width: 84%;
    display: inline-block;
    position: absolute;
    top: 46%;
    left: 8%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .md-cell-item-body:before {
    content: "";
    position: absolute;
    z-index: 2;
    -webkit-transform: scaleY(0.5) translateY(100%);
    transform: scaleY(0.5) translateY(100%);
    bottom: 0;
    left: 0;
    right: auto;
    top: auto;
    width: 100%;
    border-bottom: 0.02rem solid #e2e4ea;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
  }

  .tip {
    margin-left: 0.1rem;
    font-size: 0.2rem;
    color: #e51c23;
  }

  .md-cell-item-body {
    padding: 0;
  }
}
</style>
